import { render, staticRenderFns } from "./AdminHoursBookedByClientPerMonth.vue?vue&type=template&id=0e4432a8"
import script from "./AdminHoursBookedByClientPerMonth.vue?vue&type=script&lang=js"
export * from "./AdminHoursBookedByClientPerMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports